/* Portfolio lightbox: swipe left/right to move between artworks.

   Works alongside portfolio-lightbox-zoom.js, which owns pinch/pan/double-tap
   zoom on the lightbox image and captures the pointer for that. This script
   only tracks a single touch pointer on the same image and, on release,
   checks whether it was a clean horizontal swipe rather than a pinch or a
   pan. When the image is zoomed in (scale > 1), the gesture is left alone so
   panning keeps working normally; swiping only navigates while at the
   resting 1x zoom level.

   Navigation reuses the lightbox's own prev/next buttons (a real click),
   so it stays in sync with whatever the gallery block itself does on
   navigate - no need to reach into its internals.

   Audit fix (Sep 23): the prev/next button is now looked up inside the
   lightbox the swiped image belongs to. Before, it clicked the first
   lightbox on the page, so a page with two galleries would move the wrong
   one.
*/
(function () {
  "use strict";

  var SWIPE_THRESHOLD = 50; // minimum horizontal px to count as a swipe
  var RESTRAINT = 100; // maximum vertical px allowed during the swipe
  var MAX_DURATION = 600; // ms

  var tracking = false;
  var pointerId = null;
  var startX = 0;
  var startY = 0;
  var startTime = 0;

  function isLightboxImg(el) {
    return el && el.nodeType === 1 && el.matches && el.matches("[data-lightbox-img]");
  }

  function currentScale(el) {
    var t = el.style.transform || "";
    var m = t.match(/scale\(([\d.]+)\)/);
    return m ? parseFloat(m[1]) : 1;
  }

  document.addEventListener(
    "pointerdown",
    function (e) {
      if (!isLightboxImg(e.target)) return;
      if (e.pointerType !== "touch") return;

      if (tracking) {
        // A second finger landed - this is turning into a pinch, not a swipe.
        tracking = false;
        return;
      }

      tracking = true;
      pointerId = e.pointerId;
      startX = e.clientX;
      startY = e.clientY;
      startTime = Date.now();
    },
    true
  );

  document.addEventListener(
    "pointerup",
    function (e) {
      if (!tracking || e.pointerId !== pointerId) return;
      tracking = false;

      if (!isLightboxImg(e.target)) return;
      if (currentScale(e.target) > 1.05) return; // zoomed in - let panning own this gesture

      var dx = e.clientX - startX;
      var dy = e.clientY - startY;
      var dt = Date.now() - startTime;

      if (Math.abs(dx) < SWIPE_THRESHOLD) return;
      if (Math.abs(dy) > RESTRAINT) return;
      if (dt > MAX_DURATION) return;

      var selector = dx < 0 ? "[data-lightbox-next]" : "[data-lightbox-prev]";
      var box = e.target.closest("[data-lightbox]") || document;
      var button = box.querySelector(selector);
      if (button) button.click();
    },
    true
  );

  document.addEventListener(
    "pointercancel",
    function (e) {
      if (e.pointerId === pointerId) tracking = false;
    },
    true
  );
})();
